import React from "react";
import styled from "styled-components";

type TextSectionProps = {
  children: React.ReactNode;
};

export const TextSection = ({ children }: TextSectionProps) => {
  return <StyledTextSection>{children}</StyledTextSection>;
};

const StyledTextSection = styled.div`
  color: var(--text-gray-8);
  font: var(--body-medium-400);
  & > b {
    font: var(--body-medium-600);
  }
`;
